import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;
const storageUrl = process.env.REACT_APP_ORIKOMI_EXCLUSIVE_STORAGE;

const API_URL_ORDER = baseUrl + "/api/v1/order/search";
const API_URL_ORDER_DETAIL = baseUrl + "/api/v1/order/ref";
const API_URL_ORDER_UPDATE_STATUS = baseUrl + "/api/v1/order/update_status";

const API_URL_ORDER_MEIDA = storageUrl + "/api/v1/order/download_media";
const API_URL_ORDER_MEIDA_NAME = storageUrl + "/api/v1/order/media_name";

const API_URL_DESTINATIONS = baseUrl + "/api/v1/destinations/read";

const API_URL_UPDATE_ORDER_DESTINATION =
  baseUrl + "/api/v1/order/update_destinations";

const API_URL_UPDATE_DISTRIBUTION_QUANTITY =
  baseUrl + "/api/v1/order/update_destination_quantity";

const API_URL_DELETE_DISTRIBUTION_DESTINATION =
  baseUrl + "/api/v1/order/delete_destinations";

const API_URL_CONFIRM_DISTRIBUTION_DESTINATION =
  baseUrl + "/api/v1/order/fixed_destinations";

const API_URL_SYNC_SET_DATA = baseUrl + "/api/v1/order/sync/set_data";
const API_URL_SYNC_SET_DATA_ORIKOMI =
  baseUrl + "/api/v1/order/set_product_name";

const API_URL_GET_ITEM_CSV = baseUrl + "/api/v1/order/items_csv";
const API_URL_DOWNLOAD_CSV_LIST =
  baseUrl + "/api/v1/order/store_list_csv/download";

// Get Order Sort/Search
// @GET
const getSearchOrder = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_ORDER, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};
// @GET
const getItemCsv = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_GET_ITEM_CSV, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

const getListCsv = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_DOWNLOAD_CSV_LIST, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Get Order Detail
// @GET
const getOrderDetail = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_ORDER_DETAIL, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Get Media Download
// @POST
const getOrderMedia = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_ORDER_MEIDA, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};
const getOrderMediaName = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_ORDER_MEIDA_NAME, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Update Order Status
// @POST
const updateOrderStatus = async (dataStatusChange, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(
    API_URL_ORDER_UPDATE_STATUS,
    dataStatusChange,
    config
  );

  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Get Distributions Area
// @GET
const getDestinationsArea = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_DESTINATIONS, null, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Update Order Distribution
// @POST
const updateOrderDestination = async (dataUpdateOrderDestination, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(
    API_URL_UPDATE_ORDER_DESTINATION,
    dataUpdateOrderDestination,
    config
  );
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Update Distribution Quantity
// @POST
const updateDistributionQuantity = async (dataQuantityChange, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(
    API_URL_UPDATE_DISTRIBUTION_QUANTITY,
    dataQuantityChange,
    config
  );
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Update Delete Distribution Destination
// @POST
const deleteDistributionDestination = async (dataDelete, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(
    API_URL_DELETE_DISTRIBUTION_DESTINATION,
    dataDelete,
    config
  );
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Confirm Distribution Destination
// @POST
const confirmDistributionDestination = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(
    API_URL_CONFIRM_DISTRIBUTION_DESTINATION,
    data,
    config
  );

  const newToken = res.headers.authorization;
  return { res, newToken };
};

// =========================== Sync ===========================
// Update Sync
// @POST
const updateSyncData = async (dataSync, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_SYNC_SET_DATA, dataSync, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// @POST
const updateSyncDataOrikomi = async (dataSync, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_SYNC_SET_DATA_ORIKOMI, dataSync, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

const orderService = {
  // getOrderStatus,
  getSearchOrder,
  getOrderDetail,
  getOrderMedia,
  getOrderMediaName,
  updateOrderStatus,
  getDestinationsArea,
  updateOrderDestination,
  updateDistributionQuantity,
  deleteDistributionDestination,
  confirmDistributionDestination,
  updateSyncData,
  updateSyncDataOrikomi,
  getItemCsv,
  getListCsv,
};

export default orderService;
